export default function FormatQuery(list) {
  return list
    .map((item, index) => {
      return `${item}${index + 1 === list.length ? "" : ","}`;
    })
    .join("");
}
